// extracted by mini-css-extract-plugin
export default {"linkColor":"Header_linkColor__wE3HQ","navbar":"Header_navbar__UxM3H","navBrand":"Header_navBrand__CRaBH","nav":"Header_nav__1ZTJA"};